import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { AuthService } from '../../../services/auth.service';
import { Log } from '../../../utils/index';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.html'
})
export class HeaderComponent {
  constructor(
    public location: Location,
    protected authService: AuthService,
    protected router: Router
  ) {}

  getStyleLink(link: string): boolean {
    return true;
  }

  @Log('blue')
  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/core/header/header.component.ts